import "./BathroomRemodeling2.module.css";
import Header from "@/reusable_sections/Header";
import BathroomAnswer from "./sections/BathroomAnswer";
import BathroomDecisions from "./sections/BathroomDecisions";
import TimelineTriggers from "./sections/TimelineTriggers";
import RemodelingProcess from "./sections/RemodelingProcess";
import BathroomFaq from "./sections/BathroomFaq";
import ConsultationCallToAction from "./sections/ConsultationCallToAction";
import BathroomCta from "./sections/BathroomCta";
import EstimateRequestForm from "./sections/EstimateRequestForm";
import Footer from "@/reusable_sections/Footer";
export default function BathroomRemodeling2Page() {
  return <div>
      <Header />
      <BathroomAnswer />
      <BathroomDecisions />
      <BathroomCta />
      <TimelineTriggers />
      <RemodelingProcess />
      <BathroomFaq />
      <EstimateRequestForm />
      <ConsultationCallToAction />
      <Footer />
    </div>;
}